/**
 * Created with IntelliJ IDEA.
 * User: noam
 * Date: 1/14/14
 * Time: 5:02 PM
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var ContentCannedGridViewModel = require("content-models/canned/ContentCannedGridViewModel");
    var CannedCollection = require("content-collections/CannedCollection");
    var SelectableCollectionDecorator = require("decorators/SelectableCollectionDecorator");
    var OrganizeCollectionDecorator = require("decorators/organizeCollectionDecorator/OrganizeCollectionDecorator");
    var DropdownMenu = require("ui/dropdown-menu/DropdownMenu");
    var Constant = require("content-config/constant.json");

    var ContentCannedTablePageModel = {};

    //list of keys on the Content JSON instead of repeating strings everywhere  baha ha ha ha
    var KEYS = {
        type:       "type",
        selectable: "collections.selectable",
        gridViewModel: "collections.gridViewModel",
        organized:  "collections.organized",
        pageInfo:        "pageInfo",
        pageInfoTotals:  "pageInfo.totalPages",
        pageInfoCurrent: "pageInfo.currentPageNumber",
        pageSize:   "pageSize",
        actionsCollection:    "actions.collection",
        actionsConfig:    "actions.config"
    };

    var TYPES = Constant.CONTENT_TYPES;

    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentCannedTablePageModel = BaseModel.extend({
            name: "ContentCannedTablePageModel",
            defaults: {
                type:  TYPES.CANNED,
                collections: {
                    selectable: {},
                    organized: {},
                    gridViewModel: {}
                },
                actions: {
                    collection: {},
                    config: [
                        {
                            id: "create",
                            actionName: LE.translator.translate("LEFramework.global.captions.add"),
                            enabled: true,
                            title: LE.translator.translate("LEContent.content.gallery.action.newcontent.tooltip.text"),
                            align: "right"
                        },
                        {
                            id: "edit",
                            actionName: LE.translator.translate("LEFramework.global.captions.edit"),
                            enabled: false,
                            align: "right"
                        },
                        {
                            id: "skills",
                            actionName: LE.translator.translate("LEContent.content.gallery.menu.action.assignSkills"),
                            //title: LE.translator.translate("LEContent.content.gallery.menu.action.assignSkills.tooltip"),
                            enabled: false,
                            align: "right"
                        },
                        {
                            id: "delete",
                            actionName: LE.translator.translate("LEFramework.global.captions.delete"),
                            enabled: false,
                            align: "right"
                        },
                        {
                            id: "import",
                            actionName: LE.translator.translate("LEContent.content.gallery.menu.action.import"),
                            title: LE.translator.translate("LEContent.content.gallery.menu.action.import.tooltip"),
                            enabled: true,
                            align: "right"
                        },
                        {
                            id: "export",
                            actionName: LE.translator.translate("LEContent.content.gallery.menu.action.export"),
                            title: LE.translator.translate("LEContent.content.gallery.menu.action.export.tooltip"),
                            enabled: true,
                            align: "right"
                        },
                        {
                            id: "legacyExport",
                            actionName: LE.translator.translate("LEContent.content.gallery.menu.action.legacy.export"),
                            title: LE.translator.translate("LEContent.content.gallery.menu.action.legacy.export.tooltip"),
                            enabled: true,
                            align: "right"
                        },
                        {
                            id: "categories",
                            actionName: LE.translator.translate("LEContent.content.gallery.menu.action.manageCategories"),
                            title: LE.translator.translate("LEContent.content.gallery.menu.action.manageCategories.tooltip"),
                            enabled: true,
                            align: "right"
                        }
                    ]
                },
                pageInfo: {
                    currentPageNumber: 0,
                    totalPages: 1
                },
                pageSize: 25
            },

            initialize: function (options) {
                this.set(KEYS.selectable, SelectableCollectionDecorator.decorate(new CannedCollection()));
                this.set(KEYS.gridViewModel, new ContentCannedGridViewModel());
                this.set(KEYS.organized, OrganizeCollectionDecorator.decorate(this.getCollection(), {
                    pageSize: this.get(KEYS.pageSize),
                    lazy: true
                }));
                this._prepareCannedActions();
                this._initActionsDropdown();
                this._initTypeAndListeners();
            },

            _prepareCannedActions: function () {
                // remove import action if user don't have appropriate privileges
                if (!LEContent.context.get(LEContent.context.KEYS.hasContentImportPrivileges)) {
                    this._removeCannedAction("import");
                }
                // remove the legacy export action if not LPA
                if(!LE.sessionManager.getConfig().isLPA) {
                    this._removeCannedAction("legacyExport");
                }
            },

            _removeCannedAction: function (actionId) {
                var action = _.find(this._getCannedActions(), function (ac) {
                    return ac.id === actionId;
                });
                this._getCannedActions().splice(_.indexOf(this._getCannedActions(), action), 1);
            },

            _getCannedActions: function () {
                return this.get(KEYS.actionsConfig);
            },

            //init actions according to collection type
            _initActionsDropdown: function (type) {
                this.set(KEYS.actionsCollection,new DropdownMenu.Collection(this.get(KEYS.actionsConfig)));
            },

            _initTypeAndListeners: function(type) {
                this.stopListening(this.getCollection());
                this.stopListening(this.getOrganizedCollection());

                this.listenTo(this.getOrganizedCollection() ,"reset", this._onCollectionReset, this);
                this.listenTo(this.getCollection(), "change:selection", this._onSelectionChanged, this);
            },

            _onCollectionReset: function () {
                var info = this.getOrganizedCollection().getPagerInfo();
                this.setContentPageInfo(info);
                this._onSelectionChanged();
            },
            _onSelectionChanged: function () {
                var collection = this.getCollection();
                var selectionLength = collection.getSelectionLength();

                this._setActionAvailability("delete",(selectionLength === 1),"LEContent.content.gallery.menu.action.delete.tooltip");
                this._setActionAvailability("edit",(selectionLength === 1),"LEContent.content.gallery.menu.action.edit.tooltip");
                this._setActionAvailability("skills",(selectionLength > 0),"LEContent.content.gallery.menu.action.assignSkills.tooltip");
            },

            _setActionAvailability: function(actionId,enabled,tooltipKey) {
                 var tooltip = enabled? LE.translator.translate(tooltipKey): "";
                 var actionsCollection  = this.getActions();
                 var action =  actionsCollection.get(actionId);
                 if (action) {
                     action.set({"enabled": enabled, "title": tooltip});
                 }
            },
            pageNumberChange: function(currentPageNumber) {
                this.getOrganizedCollection().organize({currentPage: currentPageNumber});
                this.setContentPageInfoCurrentPage(currentPageNumber);
            },

            getType: function() {
                return this.get(KEYS.type);
            },
            getActions: function() {
                return this.get(KEYS.actionsCollection);
            },
            getCollection: function() {
                return this.get(KEYS.selectable);
            },
            getOrganizedCollection: function() {
                return this.get(KEYS.organized);
            },
            getGridViewModel: function() {
                return this.get(KEYS.gridViewModel);
            },
            getContentPageInfoTotal: function(){
                return this.get(KEYS.pageInfoTotals);
            },
            getContentPageInfoCurrentPage: function(){
                return this.get(KEYS.pageInfoCurrent);
            },
            setContentPageInfoCurrentPage: function(currentPageIdx){
                this.set(KEYS.pageInfoCurrent,currentPageIdx);
            },
            setContentPageInfo: function(pgInfo){
                return this.set(KEYS.pageInfo,pgInfo);
            }
        });
    });

    ContentCannedTablePageModel.KEYS = KEYS;
    ContentCannedTablePageModel.TYPES = TYPES;

    return ContentCannedTablePageModel;
});
